import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App';
import { SgBootstrapTheme, SgwtConnect, SgwtWebAnalytics, SgwtWidgetContextProvider } from '@sgwt/sgwt-widgets-react';
import { SgwtAuthenticationProvider } from '@sgwt/react-shared-libs';
import { v4 as uuidv4 } from 'uuid';

// Polyfill for crypto.randomUUID is needed for sgwt-chatbot widget
if (!globalThis.crypto?.randomUUID) {
  if (!globalThis.crypto) {
    globalThis.crypto = {} as Crypto;
  }
  globalThis.crypto.randomUUID = (() => uuidv4()) as typeof crypto.randomUUID;
}
export interface GlobalConfiguration {
  appEnvironment: 'local' | 'development' | 'homologation' | 'production';
  widgetsEnvironment: 'homologation' | 'production';
  matomo: {
    siteId: string;
    baseUrl: string;
  };
  sgConnect: {
    clientId: string;
    endpoint: string;
    scope: string;
  };
  rum: {
    activate: boolean;
    serviceName: string;
    serverURL: string;
  };
  api: string;
  eudaApi: string;
  contactEmail: string;
  eudaSendDocumentation: boolean;
  isActiveGROUPv2: boolean;
}

declare global {
  interface Window {
    globalConfiguration: GlobalConfiguration;
    loadSgBootstrap: (version: string, theme: SgBootstrapTheme) => void;
    SG_BOOTSTRAP_VERSION: string;
  }
}

setTimeout(() => {
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <StrictMode>
      <SgwtWidgetContextProvider infrastructure="azure">
        <SgwtWebAnalytics
          siteId={window.globalConfiguration.matomo.siteId}
          baseUrl={window.globalConfiguration.matomo.baseUrl}
          apmRumEnabled={window.globalConfiguration.rum.activate}
          apmRumServerurl={window.globalConfiguration.rum.serverURL}
          apmRumServiceName={window.globalConfiguration.rum.serviceName}
        />

        <SgwtConnect
          clientId={window.globalConfiguration.sgConnect.clientId}
          authorizationEndpoint={window.globalConfiguration.sgConnect.endpoint}
          scope={window.globalConfiguration.sgConnect.scope}
          redirectUri="/silent-renew.html"
        />
        <SgwtAuthenticationProvider autoSignIn withSgmServiceLoader forbidInternetAccess>
          <App />
        </SgwtAuthenticationProvider>
      </SgwtWidgetContextProvider>
    </StrictMode>
  );
}, 400);
